import { CUSTOM_TYPE_MODEL_FILENAME } from "./constants.js";
import { readCustomTypeFile } from "./readCustomTypeFile.js";
const readCustomTypeModel = async (args) => {
  const model = await readCustomTypeFile({
    ...args,
    filename: CUSTOM_TYPE_MODEL_FILENAME,
    encoding: "utf8"
  });
  return {
    model: JSON.parse(model)
  };
};
export {
  readCustomTypeModel
};
//# sourceMappingURL=readCustomTypeModel.js.map
